import { Box } from "react-feather";
import clsx from "clsx";

import styles from "./location-name-plate.module.css";

interface LocationNamePlateProps {
  name: string;
  isHovered?: boolean;
  variant?: "list-item" | "header";
}

export default function LocationNamePlate({
  name,
  isHovered = false,
  variant = "list-item",
}: LocationNamePlateProps) {
  const iconSize = variant === "list-item" ? 18 : 24;
  return (
    <div
      className={clsx(styles.locName, {
        [styles.header]: variant === "header",
      })}
      data-testid="location-name"
    >
      <div
        className={clsx(styles.iconWrapper, { [styles.hovered]: isHovered })}
      >
        <Box
          data-testid="box-icon"
          data-size={iconSize}
          size={iconSize}
          className={styles.locIcon}
        />
      </div>
      {name}
    </div>
  );
}
